module.exports = __webpack_public_path__ + "static/media/homoarak.1fc7933e.ttf";